import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';
import { Button } from '../components/ui';
import { useT } from '../i18n';
import styles from './NotFound.module.css';

// Ziel des Catch-alls (routes.tsx). Vorher schob ein stiller Navigate jeden
// Vertipper, jeden veralteten geteilten Link und jeden toten Verweis aufs
// Dashboard — der Nutzer erfuhr nie, dass sein Link kaputt war. Die Seite liegt
// bewusst AUSSERHALB von RequireAuth: ein kaputter Link ist auch fuer
// Ausgeloggte ein kaputter Link. Genau deshalb muss der Haupt-Button aber den
// Login-Status kennen — siehe homeTarget unten.
export function NotFound() {
  const { t } = useT();
  const navigate = useNavigate();
  const { status } = useAuth();
  // Direkteinstieg (geteilter Link, Deep-Link, Cold Start) hat keine eigene
  // History — navigate(-1) fuehrt dann aus der App heraus bzw. ins Leere.
  const canGoBack = typeof window !== 'undefined' && window.history.length > 1;
  // Gaeste haben kein Dashboard: RequireAuth wuerde sie von dort sofort wieder
  // auf /onboarding werfen — der Button haette also nur einen Auth-Umweg
  // ausgeloest statt ein Ziel anzubieten. /onboarding ist der Pre-Login-
  // Einstieg (Tindra-Chat mit Login/Registrieren) und damit die Landing-Seite
  // von app.lorath.eu. 'loading' zaehlt bewusst mit zu den Gaesten: der
  // Zustand haelt nur Millisekunden, und fuer Eingeloggte ist der Umweg
  // folgenlos — /onboarding leitet sie selbst nach /dashboard weiter.
  const authed = status === 'authed';
  const homeTarget = authed ? '/dashboard' : '/onboarding';
  // Beschriftung nur aus Server-Keys, die in allen 68 Sprachen gepflegt sind.
  const homeLabel = authed ? t('app.not_found_home') : t('onboarding.tree.placeholder.go_login');

  return (
    <main className={styles.page}>
      <div className={styles.card}>
        <p className={styles.code} aria-hidden="true">404</p>
        <h1 className={styles.title}>{t('app.not_found_title')}</h1>
        <p className={styles.text}>{t('app.not_found_text')}</p>
        <div className={styles.actions}>
          {/* replace: die tote URL soll nicht in der History liegen bleiben,
              sonst landet „Zurueck" vom Ziel wieder auf dem 404. */}
          <Button variant="primary" onClick={() => navigate(homeTarget, { replace: true })}>
            {homeLabel}
          </Button>
          {canGoBack ? (
            <Button variant="secondary" onClick={() => navigate(-1)}>
              {t('app.not_found_back')}
            </Button>
          ) : null}
        </div>
      </div>
    </main>
  );
}
